import React, { useEffect, useState } from 'react';
import "../../Assets/Css/Designation.scss";
import Table from '../../Components/Table';
import Select from 'react-select';
import moment from 'moment';
import { customStyle } from '../../Components/Style';
import { getUsers } from '../../Services/Users/action';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { exportData } from '../../Lib/exportData';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';

const AttendanceReport = (props) => {
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [inData, setInData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [totalSelectedIds, setTotalSelectedIds] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const isEmployee = props.user.role?.name === 'employee';

    useEffect(() => {
        if (!props?.user) {
            return;
        }
        const options = {
            module: 'attendance-report',
            id: isEmployee ? props.user.id : null
        };
        props.getUsers(options);
    }, [props?.user]);

    const monthOptions = moment.months().map((month, index) => ({
        value: index + 1,
        label: month,
    }));

    const currentYear = moment().year();
    const yearOptions = Array.from({ length: 11 }, (_, i) => ({
        value: currentYear - 5 + i,
        label: currentYear - 5 + i,
    }));

    let footer = true;

    const header = [
        { field: 'checkbox' },
        { field: 'Employee' },
        { field: 'First Week' },
        { field: 'Second Week' },
        { field: 'Third Week' },
        { field: 'Fourth Week' },
        { field: 'Fifth Week' },
        { field: 'Taken Leave' },
        { field: 'Remaining Leave' }
    ];

    useEffect(() => {
        const weeksInMonth = (month, year) => {
            const weeks = [];
            const start = moment().year(year).month(month - 1).startOf('month');
            const end = moment().year(year).month(month - 1).endOf('month');

            let current = start.clone();
            while (current.isBefore(end)) {
                const weekStart = current.clone().startOf('week');
                const weekEnd = current.clone().endOf('week');
                weeks.push([weekStart, weekEnd]);
                current.add(1, 'week');
            }
            return weeks;
        };

        const selectedM = selectedMonth?.value || moment().month() + 1;
        const selectedY = selectedYear?.value || moment().year();

        const currentMonthWeeks = weeksInMonth(selectedM, selectedY);

        const filteredUsers = isEmployee
            ? props?.users?.filter(u => u?.id === props?.user?.id)
            : props?.users;
        const report = filteredUsers?.map(user => {
            const attendance = user?.attendance || [];

            const weeklyAttendance = currentMonthWeeks.map(([start, end]) => {
                const entriesThisWeek = attendance.filter(entry => {
                    const entryDate = moment(entry?.date);
                    return entryDate.isBetween(start, end, 'day', '[]');
                });

                const groupedByDate = {};

                entriesThisWeek.forEach(entry => {
                    const dateKey = moment(entry?.date).format('YYYY-MM-DD');
                    if (!groupedByDate[dateKey]) groupedByDate[dateKey] = [];
                    groupedByDate[dateKey].push(entry);
                });

                const totalDays = Object.keys(groupedByDate).length;

                const totalMinutes = Object.values(groupedByDate).reduce((total, entries) => {
                    let dailyMinutes = 0;

                    entries.forEach(entry => {
                        const clockIn = moment(entry?.clock_in, 'HH:mm');
                        let clockOut;

                        if (entry?.clock_out) {
                            clockOut = moment(entry?.clock_out, 'HH:mm');
                        } else {
                            const isToday = moment(entry?.date).isSame(moment(), 'day');
                            if (!isToday) {
                                const assumeEnd = clockIn.clone().add(8, 'hours');
                                const midnight = clockIn.clone().endOf('day');
                                const extraTime = Math.max(midnight.diff(assumeEnd, 'minutes'), 0);
                                clockOut = assumeEnd.clone().add(extraTime, 'minutes');
                            } else {
                                return;
                            }
                        }


                        const duration = moment.duration(clockOut.diff(clockIn));
                        dailyMinutes += duration.asMinutes();
                    });

                    return total + dailyMinutes;
                }, 0);
                const totalWorkedHoursDecimal = +(totalMinutes / 60).toFixed(2);

                const difference = totalMinutes - (40 * 60);
                const diffAbs = Math.abs(difference);
                const diffHours = Math.floor(diffAbs / 60);
                const diffMinutes = Math.floor(diffAbs % 60);
                const diffSeconds = Math.round((diffAbs - Math.floor(diffAbs)) * 60);

                const diffLabel = `${difference >= 0 ? `${diffHours}h ${diffMinutes}m` : `0h 0m`}`;

                return {
                    value: `${totalWorkedHoursDecimal >= 40 ? `40` : `${totalWorkedHoursDecimal}`}/40`,
                    value2: diffLabel,
                    type: 'text'
                };
            });

            const leaveCount = user?.leave?.reduce((sum, l) => {
                const isSameMonth = moment(l?.start_date).month() + 1 === selectedM;
                const isSameYear = moment(l?.start_date).year() === selectedY;
                const isApproved = l?.status === "Approved";
                const leaveValue = parseFloat(l?.casual || 0) + parseFloat(l?.unpaid || 0);

                if (isApproved && isSameMonth && isSameYear) {
                    return sum + leaveValue;
                }

                return sum;
            }, 0);
            return {
                checkbox: {
                    value: user?.id,
                    type: "checkbox",
                },
                Employee: {
                    value: user?.name,
                    value2: user?.designation?.name,
                    src: user?.profile_pic?.data || '',
                    type: 'client',
                },
                "First Week": weeklyAttendance[0] || { value: '0/0', value2: '0h 0m', type: 'text' },
                "Second Week": weeklyAttendance[1] || { value: '0/0', value2: '0h 0m', type: 'text' },
                "Third Week": weeklyAttendance[2] || { value: '0/0', value2: '0h 0m', type: 'text' },
                "Fourth Week": weeklyAttendance[3] || { value: '0/0', value2: '0h 0m', type: 'text' },
                "Fifth Week": weeklyAttendance[4] || { value: '0/0', value2: '0h 0m', type: 'text' },
                "Taken Leave": {
                    value: leaveCount,
                    type: 'text'
                },
                "Remaining Leave": {
                    value: user?.casual_leave,
                    type: 'text'
                },
                allData: {
                    ...user
                },
            };
        });

        const finalFilteredData = report.filter(item => {
            if (!searchTerm) return true;
            return item?.Employee?.value?.toLowerCase().includes(searchTerm.toLowerCase());
        });

        setInData(finalFilteredData);
    }, [props?.users, selectedMonth, selectedYear, searchTerm]);

    const handleClear = () => {
        setSearchTerm("");
        setSelectedMonth(null);
        setSelectedYear(null);
    }

    const handleXlsxDownload = (Ids) => {
        const excludedFields = ['checkbox', 'Action'];
        const columns = header
            .filter(col => !excludedFields.includes(col.field))
            .map(col => ({
                label: col.field,
                key: col.field
            }));

        const selectedData = inData
            .filter(item => Ids.includes(item.allData?.id))
            .map(row => {
                const newRow = {};

                columns.forEach(({ label, key }) => {
                    const cell = row[key];

                    if (!cell) {
                        newRow[label] = '';
                    } else if (Array.isArray(cell.value)) {
                        newRow[label] = cell.value.join(', ');
                    } else {
                        newRow[label] = cell.value ?? '';
                    }
                });

                return newRow;
            });

        exportData({
            data: selectedData,
            columns,
            fileName: 'Attendance_Time_Report',
            format: 'xlsx',
        });
        setExportLoading(false)
        setTotalSelectedIds([])
    };


    const handleClick = async (totalSelectedIds, type) => {
        let ids = totalSelectedIds.map((id) => parseFloat(id));

        try {
            if (type === 'delete') {
                setDeleteLoading(true);
                await props.deletePurchaseInvoices(ids);
                setChecked(false);
                setTotalSelectedIds([]);
            } else if (type === 'export') {
                setExportLoading(true);
                handleXlsxDownload(ids);
                toast.success('Exported Successfully');
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleChange = (event) => {
        const { type, checked, id, ids } = event;

        if (type === "select-all") {
            setTotalSelectedIds(checked ? [...ids] : []);
        } else if (type === "select-one") {
            if (checked) {
                setTotalSelectedIds(prev => [...prev, id]);
            } else {
                setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
            }
        }
    };

    return (
        <div className='designation-container'>
            <div className='designation-header'>
                <p className='designation-title'>
                    {
                        props.loading ? (
                            <Skeleton className='rounded-2' width={200} height={40} />
                        ) : (
                            "Attendance Report"
                        )
                    }
                </p>
            </div>
            <div className='report-filter-part'>
                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width={200} height={40} />
                    ) : (
                        <div className="input-group">
                            <input type="text" className="input-css" name='search' placeholder='Search..'
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value)
                                }} />
                        </div>
                    )
                }

                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width={200} height={40} />
                    ) : (
                        <div className="input-group">
                            <Select
                                options={monthOptions}
                                styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                    }),
                                }}
                                value={selectedMonth}
                                placeholder='Month'
                                onChange={(val) => setSelectedMonth(val)}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                        </div>
                    )
                }

                {
                    props.loading ? (
                        <Skeleton className='rounded-2' width={200} height={40} />
                    ) : (
                        <div className="input-group">
                            <Select
                                options={yearOptions}
                                styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                    }),
                                }}
                                value={selectedYear}
                                placeholder='Year'
                                onChange={(val) => setSelectedYear(val)}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                        </div>
                    )
                }

                <div className='edit-btn'>
                    {(searchTerm || selectedMonth?.value || selectedYear?.value) && (
                        props.loading ? (
                            <Skeleton className='badge rounded-pill' width={100} height={40} />
                        ) : (
                            <button
                                type="submit"
                                className="custom-btn"
                                onClick={handleClear}
                            >
                                Clear
                            </button>
                        )
                    )}
                </div>
            </div>

            <div className='designation-action-button'>
                {
                    props.loading ? (
                        <Skeleton className='badge rounded-pill' width={100} height={40} />
                    ) : (
                        <div className="edit-btn">
                            <button
                                className="export-btn"
                                id="exportBtn"
                                disabled={totalSelectedIds.length <= 0 || exportLoading}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleClick(totalSelectedIds, 'export');
                                }}
                            >Export
                            </button>
                        </div>
                    )
                }
            </div>

            <div className="Designation-table-part">
                {
                    props.loading ? (
                        <Skeleton className='rounded-2' count={5} width="100%" height={40} />
                    ) : (
                        <Table
                            loading={props?.loading}
                            header={header}
                            footer={footer}
                            data={inData}
                            count={inData?.length}
                            records={inData?.length}
                            totalSelectedIds={totalSelectedIds}
                            handleChange={handleChange}
                        />
                    )
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        loading: state.userReducer.loading,
        users: state.userReducer.users,
        attendance: state.attendanceReducer.attandance,
        task: state.taskReducer.task,
        user: state.authenticationReducer.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getUsers: (options) => {
            dispatch(getUsers(options))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceReport);
